import { Router } from '@angular/router';
import { PortalProducts } from '@shared/enumeration';

export const NotificationActions = {
  'integration-analytics-elosResponse-received': {
    actionFn: (router: Router, payload: any) =>
      router.navigate(
        [payload.tenantId, PortalProducts.PACIM, 'auth-dashboard', payload.authorizationNumber],
        { fragment: 'clinicalResponses'}
      ),
  },
    'integration-analytics-rtd-recommended': {
    actionFn: (router: Router, payload: any) =>
      router.navigate(
        [payload.tenantId, PortalProducts.PACIM, 'auth-dashboard', payload.authorizationNumber],
        { fragment: 'clinicalResponses'}
      ),
  },
    'integration-analytics-rtd-not-recommended': {
    actionFn: (router: Router, payload: any) =>
      router.navigate(
        [payload.tenantId, PortalProducts.PACIM, 'auth-dashboard', payload.authorizationNumber],
        { fragment: 'clinicalResponses'}
      ),
  },
};
